import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FormError } from './FormError';
import styles from './Input.module.css';
export const Input = ({ name, required, register, error }) => {
    const isRequired = required ?? true;
    return (_jsxs("div", { children: [_jsx("input", { id: name, className: `${styles.input} ${error ? styles.error : ''}`, type: "text", autoComplete: "off", "aria-invalid": !!error, "aria-errormessage": `#error-${name}`, "aria-required": isRequired, ...register(name, { required: isRequired }) }), _jsx(FormError, { id: `error-${name}`, error: error?.message, inputId: name })] }));
};
